import { AdminLinkList } from '../../../components/Links/AdminLinksList'

export const LinksList = () => {
    return <AdminLinkList />
}
